















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'PlaceLogo',
})
export default class PlaceLogo extends Vue {
  @Prop({
    type: String,
    default: null,
  })
  logo!: string|null;
}
